export default "__VITE_ASSET___Tln74LF__"